import { gql } from 'apollo-boost';
import moment from 'moment';

const query = gql`
  query carrierBatches(
    $orgId: ID!
    $carrierId: Int
    $from: Date
    $to: Date
    $limit: Int!
    $offset: Int!
  ) {
    remittanceBatch {
      carrierBatches(
        orgId: $orgId
        carrierId: $carrierId
        processedFrom: $from
        processedTo: $to
        limit: $limit
        offset: $offset
      ) {
        totalCount
        results {
          id
          carrierId
          carrierName
          totalAmountDue
          invoiceCount
          createdUtc
          remittanceBatchId
        }
      }
    }
  }
`;
export const retrieveListData = async (
  orgId,
  carrierId,
  fromDate,
  toDate,
  rowsPerPage,
  offset,
  ApolloClient
) => {
  const {
    data: {
      remittanceBatch: { carrierBatches }
    }
  } = await ApolloClient.query({
    query,
    variables: {
      orgId,
      carrierId,
      from: fromDate,
      to: toDate,
      limit: rowsPerPage,
      offset
    }
  });

  // map results
  carrierBatches.results = carrierBatches.results.map(o => ({
    ...o,
    createdLocal: moment.utc(o.createdUtc).local()
  }));

  return carrierBatches;
};
